export const pocEndpoints = {
    // setup site
    site_create: 'Site',
    site_update: 'Site',

    // setup product
    product_create: 'Product',
    product_update: 'Product',
}
